/**
 * AccordionContainer - accordion wrapper coordinating its header/body items.
 * Custom element: <accordion-container>
 *
 * Refs:
 *   [data-ref="accordionHeader"]  (required)
 *   [data-ref="accordionBody"]  (required)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import "./component-AccordionHeader.js";
import "./component-AccordionBody.js";
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class AccordionContainer extends ThemeComponent {
  init() {
    this.$subscribe(this.accordionHeader.onOpenChange, this.toggleOpen.bind(this));
  }
  toggleOpen() {
    this.classList.toggle("accordion-container--open");
  }
}
setFunctionName(AccordionContainer, "AccordionContainer");
const propertyTypes = {};
AccordionContainer.prototype.$name = "AccordionContainer";
AccordionContainer.prototype.$info = JSON.parse('{"name":"AccordionContainer","meta":{"isLegacy":false,"selector":"accordion-container"},"props":[],"refs":[{"selector":"[data-ref=\\"accordionHeader\\"]","required":true,"propertyKey":"accordionHeader","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"AccordionHeader"},{"selector":"[data-ref=\\"accordionBody\\"]","required":true,"propertyKey":"accordionBody","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"AccordionBody"}]}');
AccordionContainer.prototype.$info.component = AccordionContainer;
for (const prop of AccordionContainer.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Accordion/AccordionContainer.ts", {
  AccordionContainer: AccordionContainer
}, void 0);